import { FC } from "react";
import SourceDataItemValue, { ISourceDataItemValueProps } from "./SourceDataItemValue";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { AppSettings } from "@/AppSettings";

const SourceDataItemTextValue: FC<ISourceDataItemValueProps> = ({
    itemData,
    hideBorderStyles,
    hideStyles
}) => {
    return (
        <SourceDataItemValue
            hideBorderStyles={hideBorderStyles}
            hideStyles={hideStyles}
            // startAdornment={
            //     <FontAwesomeIcon 
            //         size="lg"
            //         icon={AppSettings.icons.itemValueText} 
            //     />
            // }
        >
            {itemData?.value}
        </SourceDataItemValue>
    );
};

export default SourceDataItemTextValue;